import api from "../axiosInstance";

const vehicleService = {
  updateRecallStatus: (leadId, action) =>
    api.put(`/vehicle/${leadId}/recall`, {
      action
    }),
  exportCSV: (formData) =>
    api.post("/vehicle/exportCSV", formData, {
      headers: {
        "Content-Type": "application/json"
      }
    }),
  getFilters: () => api.get("/vehicle/filter"),
  getFiltersV2: () => api.get("/vehicle/filter/v2")
};

export default vehicleService;
